/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
import * as i0 from "@angular/core";
import * as i1 from "./callback.component";
import * as i2 from "@angular/router";
import * as i3 from "../../api/service/tower.service";
import * as i4 from "../../shared/navigation.service";
var styles_CallbackComponent = [];
var RenderType_CallbackComponent = i0.ɵcrt({ encapsulation: 2, styles: styles_CallbackComponent, data: {} });
export { RenderType_CallbackComponent as RenderType_CallbackComponent };
export function View_CallbackComponent_0(_l) { return i0.ɵvid(0, [], null, null); }
export function View_CallbackComponent_Host_0(_l) { return i0.ɵvid(0, [(_l()(), i0.ɵeld(0, 0, null, null, 1, "app-callback", [], null, null, null, View_CallbackComponent_0, RenderType_CallbackComponent)), i0.ɵdid(1, 114688, null, 0, i1.CallbackComponent, [i2.Router, i2.ActivatedRoute, i3.TowerService, i4.NavigationService], null, null)], function (_ck, _v) { _ck(_v, 1, 0); }, null); }
var CallbackComponentNgFactory = i0.ɵccf("app-callback", i1.CallbackComponent, View_CallbackComponent_Host_0, {}, {}, []);
export { CallbackComponentNgFactory as CallbackComponentNgFactory };



// WEBPACK FOOTER //
// ./src/app/page/callback/callback.component.ngfactory.js.pre-build-optimizer.js